"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRunQueryById = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
const react_1 = require("react");
function useRunQueryById(id) {
    const [queryId, setQueryId] = (0, react_1.useState)();
    const [expressionMap, setExpressionMap] = (0, react_1.useState)();
    const [returnType, setReturnType] = (0, react_1.useState)();
    // reference id
    const idRef = (0, react_1.useRef)(id);
    (0, react_1.useEffect)(() => void (idRef.current = id), [id]);
    const { data, isLoading, error, post } = (0, core_ui_1.useApiPost)(`queries/${queryId}/run`);
    // fetch site when path is set
    (0, react_1.useEffect)(() => void (queryId && post({ expressionMap, returnType })), [queryId, expressionMap, returnType, post]);
    // clear out path state after fetching
    (0, react_1.useEffect)(() => (data || error) && setQueryId(undefined), [data, error]);
    const runQuery = (0, react_1.useCallback)((queryId, expressionMap) => {
        setQueryId(typeof queryId === 'string' ? queryId : idRef.current);
        setExpressionMap(expressionMap);
    }, []);
    const runPaginatedQuery = (0, react_1.useCallback)((queryId, expressionMap) => {
        runQuery(queryId, expressionMap);
        setReturnType('paginated');
    }, [runQuery]);
    const runQueryGetOne = (0, react_1.useCallback)((queryId, expressionMap) => {
        runQuery(queryId, expressionMap);
        setReturnType('one');
    }, [runQuery]);
    const runQueryOrPaginated = (0, react_1.useCallback)((queryId, paginated, expressionMap) => {
        if (!queryId) {
            // do nothing if no queryId
            return;
        }
        else if (paginated) {
            runPaginatedQuery(queryId, expressionMap);
        }
        else {
            // remove limit and offset for non paginated query
            const map = __rest(expressionMap, []);
            delete map.limit;
            delete map.offset;
            runQuery(queryId, map);
        }
    }, [runPaginatedQuery, runQuery]);
    return {
        queryId,
        queryData: data,
        isRunningQuery: isLoading,
        runQueryError: error,
        runQuery,
        runPaginatedQuery,
        runQueryGetOne,
        runQueryOrPaginated
    };
}
exports.useRunQueryById = useRunQueryById;
//# sourceMappingURL=useRunQueryById.js.map